export default __webpack_public_path__ + "static/media/venmo.82262994.svg";